import { gql } from '@apollo/client';

import { useMutationCompat as useMutation } from '../../lib/apollo/mutationCompat';

const UPDATE_DESCRIPTION = gql`
  mutation ($name: String, $description: String) {
    UpdateDescription(name: $name, description: $description)
  }
`;

// SECURITY FIX: was one CustomerConfig mutation accepting both timer fields
// and MDM fields together, gated FEATURE_EDIT OR CONFIG_EDIT - meaning
// either permission alone let a caller update both field groups (input-
// field-level @auth was never actually enforced - see customer.graphql).
// Now CUSTOMER_CONFIG only ever sends co_timer/grace_period/alarm_freq
// (ConfigTimerInput, CONFIG_EDIT-gated), and MDM_ACCOUNT_CONFIG is a
// separate mutation for the 5 MDM fields (MdmAccountConfigInput,
// FEATURE_EDIT-gated).
const CUSTOMER_CONFIG = gql`
  mutation ($config: ConfigTimerInput) {
    CustomerConfig(config: $config)
  }
`;

const MDM_ACCOUNT_CONFIG = gql`
  mutation ($config: MdmAccountConfigInput) {
    MdmAccountConfig(config: $config)
  }
`;

const FEATURE_TOGGLE = gql`
  mutation ($feature: FeatureToggleInput) {
    FeatureToggle(feature: $feature)
  }
`;

export function useAccountMutations () {

  const [updateDescription] = useMutation(UPDATE_DESCRIPTION,
    { refetchQueries: ['getCustomer', 'getCustomerConfig', 'getCustomerFeatures', 'getFeatures', 'getPolicies', 'getUsers', 'getDevices'] },
  );

  const [customerConfig] = useMutation(CUSTOMER_CONFIG,
    { refetchQueries: ['getAccountConfig', 'getCustomerConfig', 'getCustomerFeatures', 'getFeatures', 'getPolicies', 'getUsers', 'getDevices'] },
  );

  const [mdmAccountConfig] = useMutation(MDM_ACCOUNT_CONFIG,
    { refetchQueries: ['getAccountConfig', 'getCustomerConfig', 'getCustomerFeatures', 'getFeatures', 'getPolicies', 'getUsers', 'getDevices'] },
  );

  const [featureToggle] = useMutation(FEATURE_TOGGLE,
    { refetchQueries: ['getAccountConfig', 'getCustomerConfig', 'getCustomerFeatures', 'getFeatures', 'getPolicies', 'getUsers', 'getDevices'] },
  );

  return { updateDescription, customerConfig, mdmAccountConfig, featureToggle };
}
